const defaultOptions = [
  {
    complexity: 0,
    value: 'Too weak',
    minComplexity: 0,
    minLength: 0,
    isValid: false,
  },
  {
    complexity: 1,
    value: 'Weak',
    minComplexity: 2,
    minLength: 8,
    isValid: true,
  },
  {
    complexity: 2,
    value: 'Medium',
    minComplexity: 3,
    minLength: 12,
    isValid: true,
  },
  {
    complexity: 3,
    value: 'Strong',
    minComplexity: 4,
    minLength: 16,
    isValid: true,
  },
];

const defaultAllowedSymbols = '!"#$%&\'()*+,-./:;<=>?@[\\\\\\]^_`{|}~';

const passwordChecker = (password, config = {}) => {
  const options = config.options ?? defaultOptions;
  const allowedSymbols = config.allowedSymbols ?? defaultAllowedSymbols;

  const rules = [
    {
      regex: '[a-z]',
      message: 'lowercase',
    },
    {
      regex: '[A-Z]',
      message: 'uppercase',
    },
    {
      regex: '[0-9]',
      message: 'number',
    },
  ]
    .concat(
      allowedSymbols
        ? {
            regex: `[${allowedSymbols}]`,
            message: 'symbol',
          }
        : false,
    )
    .filter(Boolean);

  const contains = rules.filter((rule) => new RegExp(`${rule.regex}`).test(password)).map((rule) => rule.message);
  const { length } = password;

  const fulfilledOptions = options
    .filter((option) => contains.length >= option.minComplexity)
    .filter((option) => length >= option.minLength);

  const getStrongestFulfilledOption = () =>
    options.find((option) => option.complexity === Math.max(...fulfilledOptions.map((o) => o.complexity)));

  const { value, isValid, complexity } = getStrongestFulfilledOption();

  return {
    complexity,
    value,
    isValid,
    contains,
    length,
  };
};

export { passwordChecker };
